export const LOGOUT_CLEAR_TIMEOUT = 100; // 100 ms

// Works only with `main` layout
export const PAGES_AI_DISABLED = ["settings", "accounts_settings"];
